const CODE_CHALLENGE_PATTERN = /^[A-Za-z0-9_-]{43,128}$/;

export function readCliAuthParams(search) {
  const params = new URLSearchParams(search);
  const redirectUri = params.get('redirect_uri') || '';
  const state = params.get('state') || '';
  const codeChallenge = params.get('code_challenge') || '';
  const codeChallengeMethod = params.get('code_challenge_method') || '';

  if (!redirectUri) {
    return { ok: false, error: 'Missing redirect_uri parameter.' };
  }
  if (!state) {
    return { ok: false, error: 'Missing state parameter.' };
  }
  if (codeChallengeMethod !== 'S256') {
    return { ok: false, error: 'code_challenge_method must be S256.' };
  }
  if (!CODE_CHALLENGE_PATTERN.test(codeChallenge)) {
    return { ok: false, error: 'code_challenge must be a valid S256 PKCE challenge.' };
  }

  return {
    ok: true,
    redirectUri,
    state,
    codeChallenge,
    codeChallengeMethod,
  };
}

export function buildCliCallbackUrl(redirectUri, code, state) {
  const callbackUrl = new URL(redirectUri);
  callbackUrl.searchParams.set('code', code);
  callbackUrl.searchParams.set('state', state);
  return callbackUrl.toString();
}

export async function requestCliAuthorization({ currentUser, authParams, apiBaseUrl = '' }) {
  const token = await currentUser.getIdToken();
  const response = await fetch(`${apiBaseUrl}/api/cli/v1/auth/authorize`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      redirectUri: authParams.redirectUri,
      codeChallenge: authParams.codeChallenge,
      codeChallengeMethod: authParams.codeChallengeMethod,
    }),
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.detail || `CLI authorization failed with HTTP ${response.status}`);
  }
  if (!payload?.data?.code) {
    throw new Error('CLI authorization response did not include an authorization code.');
  }

  return payload.data;
}
